import * as queryString from "query-string";
import Constant from "../constants/contant";

import * as _ from "moment";
const moment = (_ as any).default;

export interface Filters {
  search?: string;
  eventCost?: string;
  eventType?: string;
  organizingUnit?: string;
  interestedDomain?: string;
  online?: boolean;
  startDate?: number;
  endDate?: number;
  eventStatus?: string;
}

export class QueryFilters {
  constructor(
    public filters: string,
    public facets: any,
    public type?: string
  ) {}

  get parsedQuery(): Filters {
    return queryString.parse(this.filters);
  }

  get drupalQueryString(): string {
    let query: string = "";
    const filters: any = queryString.parse(this.filters);
    Object.keys(filters).map((filter) => {
      const drupalQuery = this._getDrupalFields(filter, filters[filter]);
      query += `${drupalQuery ? `&${drupalQuery}` : ""}`;
    });
    query +=
      this.type && this.type === "past"
        ? "&sort=-field_event_start_date,-field_event_start_hour_min"
        : "&sort=field_event_start_date,field_event_start_hour_min";
    return query;
  }

  updateFiltersFromObject(filters: any) {
    this.filters = queryString.stringify(filters);
  }

  private _getDrupalFields(key: string, value: string): string {
    switch (key) {
      case "eventCost":
        return `filter[${Constant.DRUPAL_FILTER_FIELDS.eventCost}]=${value}`;
      case "eventType":
        return this._getValueFromFacet(
          Constant.DRUPAL_FILTER_FIELDS.eventType,
          value
        );
      case "organizingUnit":
        return this._getValue(
          Constant.DRUPAL_FILTER_FIELDS.organizingUnit,
          value
        );
      case "interestedDomain":
        return this._getValueFromFacet(
          Constant.DRUPAL_FILTER_FIELDS.interestedDomain,
          value
        );
      case "eventStatus":
        const values = value.split(",");
        if (values.length > 1) {
          return `filter[activation_status][condition][path]=field_activation_status&filter[activation_status][condition][operator]=IN&${values
            .map(
              (val, index) =>
                `filter[activation_status][condition][value][${
                  index + 1
                }]=${val}`
            )
            .join("&")}`;
        }
        return `filter[field_activation_status]=${value}`;
      case "search":
        return `filter[${Constant.DRUPAL_FILTER_FIELDS.search}]=${value}`;
      case "online":
        return `filter[${
          Constant.DRUPAL_FILTER_FIELDS.onlineEvent
        }]=${this._getOnlineEventValue(value)}`;
      case "startDate":
        return this._getStartDateFilter(value);
      case "endDate":
        return this._getEndDateFilter(value);
      default:
        return "";
    }
  }

  private _getOnlineEventValue(value: string): number {
    return Boolean(value) ? 1 : 0;
  }

  private _getValueFromFacet(key: string, value: any): string {
    if (
      key === "field_event_interest_domains" &&
      this.facets[`${key}_${value}`]?.value
    ) {
      return `filter[event_interest_domains]=${
        this.facets[`${key}_${value}`].value
      }`;
    }
    return `filter[${key}]=${this.facets[`${key}_${value}`]?.value}`;
  }
  private _getValue(key: string, value: any): string {
    return `filter[${key}]=${value}`;
  }
  private _getStartDateFilter(value: any): string {
    return `filter[cond_1_2][condition][value]=${value}
		&filter[cond_1_2][condition][path]=field_event_end_date
		&filter[cond_1_2][condition][operator]=%3E%3D
		&filter[cond_1_2][condition][memberOf]=cond_1
		&filter[cond_1_1][condition][value]=${value}
		&filter[cond_1_1][condition][path]=field_event_start_date
		&filter[cond_1_1][condition][operator]=%3C%3D
		&filter[cond_1_1][condition][memberOf]=cond_1
		&filter[cond_2_1][condition][value]=${value}
		&filter[cond_2_1][condition][path]=field_event_start_date
		&filter[cond_2_1][condition][operator]=%3E%3D
		&filter[cond_2_1][condition][memberOf]=cond_2`;
  }

  private _getEndDateFilter(value: any): string {
    return `filter[cond_2_2][condition][value]=${value}
		&filter[cond_2_2][condition][path]=field_event_end_date
		&filter[cond_2_2][condition][operator]=%3C%3D
		&filter[cond_2_2][condition][memberOf]=cond_2`;
  }
}
